import authService from '@/repository/services/v1/auth'
import type { CredentialResponseType } from '@@/types/types'

export const useAuthProvider = async () => {
  const { $apiClient } = useNuxtApp()
  const { login, setSignUp, setCredentials, setAuthenticated } = useAuth()
  const { authController, authPresenter } = await useLcServiceAuth()

  const loginWithProviderHandle = async (
    provider: 'google' | 'apple',
    data: CredentialResponseType,
  ) => {
    await authController.loginWithProviders({
      webProps: {
        provider,
        uuid: data.sub,
        email: data.email,
      },
    })

    setCredentials(data)

    if (authPresenter.vm.navigation === 'App') {
      const { data } = await authService($apiClient).validateToken()
      await login(data)
      setAuthenticated(true)
    }

    if (authPresenter.vm.navigation === 'SignUp') setSignUp(true)
  }

  return { loginWithProviderHandle }
}
